<div class="pu-page rl">
  <div class="pu-head">
    <div class="pu-head__main">
      <h1 class="stk-page-title">Rendelési lista</h1>
      <div class="stk-page-sub">
        Ellenőrzési napok: {{ checkDaysLabel }}<ng-container *ngIf="data?.responsible"> · felelős: {{ data?.responsible }}</ng-container>
        <ng-container *ngIf="data?.lastSubmittedAt"> · utoljára leadva: {{ data?.lastSubmittedAt | date:'MMM d., HH:mm' }}</ng-container>
      </div>
    </div>
    <a class="pu-btn" routerLink="/beszerzes/beszallitok">Beszállítók és termékek</a>
    <button type="button" class="pu-btn pu-btn--danger" *ngIf="markedCount > 0" (click)="clearAll()">Lista ürítése</button>
    <button type="button" class="pu-btn" *ngIf="isAdmin && settings" (click)="openSettings()">Beállítások</button>
  </div>

  <div class="pu-card rl-settings" *ngIf="settingsOpen && settingsForm">
    <div class="pu-card__title">Beszerzési beállítások</div>
    <div class="rl-settings__body">
      <div class="pu-field">
        Ellenőrzési napok
        <div class="rl-days">
          <button type="button" class="pu-chip" *ngFor="let d of weekdays" [class.pu-chip--on]="settingsForm.days.includes(d)" (click)="toggleDay(d)">{{ dayLabels[d] }}</button>
        </div>
      </div>
      <div class="pu-grid">
        <label class="pu-field">Emlékeztetők <em>(ÓÓ:PP, vesszővel)</em>
          <input class="pu-input" [(ngModel)]="settingsForm.remindTimes" placeholder="09:00,14:00"></label>
        <label class="pu-field">Felelős (Foxi neki szól)
          <select class="pu-input" [(ngModel)]="settingsForm.responsible">
            <option [ngValue]="null">— nincs —</option>
            <option *ngFor="let p of settings?.people" [ngValue]="p.id">{{ p.name }}</option>
          </select></label>
        <label class="pu-field">Jóváhagyó <em>(és ha elmarad a lista)</em>
          <select class="pu-input" [(ngModel)]="settingsForm.approver">
            <option [ngValue]="null">— minden admin —</option>
            <option *ngFor="let p of settings?.people" [ngValue]="p.id">{{ p.name }}</option>
          </select></label>
        <label class="pu-field">Foxi önállóan rendelhet eddig <em>(bruttó Ft, 0 = mindig jóváhagyás)</em>
          <input class="pu-input" type="number" min="0" step="1000" [(ngModel)]="settingsForm.limit"></label>
      </div>
      <label class="pu-field">Megjegyzés a rendelő levelekbe <em>(pl. „munkanapokon 8–16 között vagyunk elérhetők”)</em>
        <textarea class="pu-input" rows="2" [(ngModel)]="settingsForm.deliveryNote"></textarea></label>

      <ng-container *ngIf="profileForm">
        <div class="pu-card__title rl-sub">Rendelési adatok <span class="pu-muted">— a webshopos (vendég) rendeléshez és a rendelő levelekhez</span></div>
        <div class="pu-warn" *ngIf="profile?.missing?.length">Hiányzik: {{ profile?.missing?.join(', ') }} — ezek nélkül a robot nem indul.</div>
        <div class="rl-sub2">Számlázási adatok</div>
        <div class="pu-grid">
          <label class="pu-field">Cégnév / név <input class="pu-input" [(ngModel)]="profileForm.company_name"></label>
          <label class="pu-field">Adószám <input class="pu-input" [(ngModel)]="profileForm.tax_number" placeholder="12345678-2-42"></label>
          <label class="pu-field">Kapcsolattartó <input class="pu-input" [(ngModel)]="profileForm.contact_name"></label>
          <label class="pu-field">E-mail <input class="pu-input" [(ngModel)]="profileForm.email" placeholder="beszerzes@bgfox.hu"></label>
          <label class="pu-field">Telefon <input class="pu-input" [(ngModel)]="profileForm.phone" placeholder="+36 30 …"></label>
          <label class="pu-field">Ország <input class="pu-input" [(ngModel)]="profileForm.country"></label>
          <label class="pu-field">Irányítószám <input class="pu-input" [(ngModel)]="profileForm.zip"></label>
          <label class="pu-field">Település <input class="pu-input" [(ngModel)]="profileForm.city"></label>
          <label class="pu-field">Utca, házszám <input class="pu-input" [(ngModel)]="profileForm.street"></label>
        </div>
        <div class="rl-sub2">Szállítási cím</div>
        <label class="rl-check"><input type="checkbox" [(ngModel)]="profileForm.ship_same"> Megegyezik a számlázási címmel</label>
        <div class="pu-grid" *ngIf="!profileForm.ship_same">
          <label class="pu-field">Név / cégnév <input class="pu-input" [(ngModel)]="profileForm.ship_name" [placeholder]="profileForm.company_name || ''"></label>
          <label class="pu-field">Telefon <input class="pu-input" [(ngModel)]="profileForm.ship_phone" [placeholder]="profileForm.phone || ''"></label>
          <label class="pu-field">Ország <input class="pu-input" [(ngModel)]="profileForm.ship_country" [placeholder]="profileForm.country || 'Magyarország'"></label>
          <label class="pu-field">Irányítószám <input class="pu-input" [(ngModel)]="profileForm.ship_zip"></label>
          <label class="pu-field">Település <input class="pu-input" [(ngModel)]="profileForm.ship_city"></label>
          <label class="pu-field">Utca, házszám <input class="pu-input" [(ngModel)]="profileForm.ship_street"></label>
        </div>
        <label class="pu-field">Megjegyzés a webshopos rendeléshez <em>(ha a bolt kér, pl. „kapucsengő: BGF”)</em>
          <input class="pu-input" [(ngModel)]="profileForm.note"></label>
        <label class="rl-check"><input type="checkbox" [(ngModel)]="profileForm.robot_enabled"> Webshop-robot bekapcsolva (Foxi böngészővel adja le a webshopos rendeléseket)</label>
        <label class="rl-check"><input type="checkbox" [(ngModel)]="profileForm.robot_dry_run"> Próbaüzem: a végső „Megrendelés” előtt megáll, és képernyőképpel jóváhagyást kér</label>
      </ng-container>
      <div class="rl-settings__actions">
        <button type="button" class="pu-btn" (click)="settingsOpen = false" [disabled]="savingSettings">Mégse</button>
        <button type="button" class="pu-btn pu-btn--accent" (click)="saveSettings()" [disabled]="savingSettings">{{ savingSettings ? 'Mentés…' : 'Mentés' }}</button>
      </div>
    </div>
  </div>

  <div class="pu-card" *ngIf="submitted">
    <div class="pu-card__title">Leadva 🦊</div>
    <div class="pu-card__sub" *ngIf="!submitted.length">Minden tételből van elég — most nincs mit rendelni.</div>
    <div class="rl-done" *ngFor="let o of submitted">{{ o.displayId }} · {{ o.supplier }} — {{ o.statusLabel }}</div>
    <div class="rl-done__more" *ngIf="submitted.length"><a class="pu-link" routerLink="/beszerzes/rendelesek">Rendelések megnyitása →</a></div>
  </div>

  <div class="pu-empty" *ngIf="loading">Betöltés…</div>
  <div class="pu-empty" *ngIf="loadFailed">Nem sikerült betölteni. <button type="button" class="pu-btn pu-btn--sm" (click)="load()">Újra</button></div>

  <ng-container *ngIf="data && !loading">
    <div class="pu-card pu-empty" *ngIf="!data.suppliers.length">
      Még nincs felvéve beszállító vagy termék. <a class="pu-link" routerLink="/beszerzes/beszallitok">Vedd fel itt →</a>
    </div>

    <div class="pu-card pu-card--flush" *ngFor="let s of data.suppliers">
      <div class="rl-supplier">
        <span class="pu-card__title">{{ s.name }}</span>
        <span class="pu-pill" [ngClass]="'pu-pill--' + s.orderMethod">{{ s.orderMethod === 'webshop' ? 'webshop' : 'e-mail' }}</span>
      </div>
      <div class="rl-line" *ngFor="let l of s.lines; trackBy: trackLine" [class.rl-line--open]="!l.decision">
        <div class="rl-line__main">
          <div class="rl-line__name">
            <a *ngIf="l.url; else plainName" [href]="l.url" target="_blank" rel="noopener">{{ l.name }}</a>
            <ng-template #plainName>{{ l.name }}</ng-template>
          </div>
          <div class="pu-muted">
            <ng-container *ngIf="l.supplierSku">{{ l.supplierSku }} · </ng-container>
            szokásos: {{ l.usualQty || '—' }} db
            <ng-container *ngIf="l.packSize && l.packSize > 1"> · {{ l.packSize }}-ös köteg</ng-container>
            <ng-container *ngIf="l.unitPrice !== null"> · {{ l.unitPrice | number:'1.0-2' }} Ft{{ s.pricesGross ? '' : ' + ÁFA' }}/db</ng-container>
          </div>
        </div>
        <div class="rl-line__actions">
          <button type="button" class="pu-chip" [class.pu-chip--ok]="l.decision === 'ok'" (click)="setDecision(l, 'ok')">Van elég</button>
          <button type="button" class="pu-chip" [class.pu-chip--order]="l.decision === 'order'" (click)="setDecision(l, 'order')">Rendelni kell</button>
          <button type="button" class="rl-clear" *ngIf="l.decision" (click)="clearLine(l)" title="Jelölés visszavonása" aria-label="Jelölés visszavonása">✕</button>
          <ng-container *ngIf="l.decision === 'order'">
            <input class="pu-input pu-input--qty" type="number" min="1" step="1" [ngModel]="l.quantity" (ngModelChange)="onQty(l, $event)" aria-label="Darabszám">
            <span class="pu-muted">db</span>
            <span class="pu-warn" *ngIf="l.quantity && rounded(l) !== l.quantity">→ {{ rounded(l) }} db (köteg)</span>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="pu-card rl-sum" *ngIf="data.suppliers.length">
      <div class="pu-card__title">Összesítés</div>
      <div class="pu-card__sub">{{ totalLines - unmarkedCount }} / {{ totalLines }} tétel megjelölve</div>
      <div class="rl-sum__row" *ngFor="let r of summary">
        <div class="rl-sum__main">
          <b>{{ r.name }}</b> <span class="pu-pill" [ngClass]="'pu-pill--' + r.orderMethod">{{ r.orderMethod === 'webshop' ? 'webshop' : 'e-mail' }}</span>
          <div class="pu-muted">{{ r.items }}</div>
        </div>
        <div class="rl-sum__right">
          <div class="rl-sum__total">{{ r.priced ? '≈ ' + (r.gross | number:'1.0-0') + ' Ft' : 'ár hiányzik' }}</div>
          <div class="pu-muted">{{ r.auto ? 'Foxi magától leadja' : 'jóváhagyás kell' }}</div>
        </div>
      </div>
      <div class="pu-muted" *ngIf="!summary.length">Még nincs „Rendelni kell” tétel.</div>
      <div class="rl-sum__actions">
        <span class="pu-error" *ngIf="submitError">{{ submitError }}</span>
        <button type="button" class="pu-btn pu-btn--dark" (click)="submit()" [disabled]="submitting">{{ submitting ? 'Leadás…' : 'Mehet Foxinak' }}</button>
      </div>
    </div>
  </ng-container>
</div>
